export default {"src":"/_next/static/media/currency.c3c74426.svg","height":70,"width":62,"blurWidth":0,"blurHeight":0};